import { setupAutoLogoutConfig } from './auto-logout-config';

// Adding Default AutoLogoutConfig
const autoLogoutConfig = (typeof global !== 'undefined' && global.AutoLogoutConfig) ? global.AutoLogoutConfig : {
    dialogCountDownTimeout: 60, // seconds
    userInactiveTimeout: 3600, // 1 hour
};

setupAutoLogoutConfig({
    dialogCountDownTimeout: autoLogoutConfig.dialogCountDownTimeout,
    userInactiveTimeout: autoLogoutConfig.userInactiveTimeout,
});
